import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HelpItemComponent } from '../help-item.component';
import { TranslationService } from '../../../services/translation.service';

@Component({
	selector: 'abbr',
	styleUrls: ['./abbr.component.less'],
	templateUrl: './abbr.component.html'
})
export class AbbrComponent
	extends HelpItemComponent
	implements OnInit {
	content: SafeHtml;
	constructor(private http: HttpClient,
		private dom: DomSanitizer,
		private trans: TranslationService) {
		super();
	}

	ngOnInit() {
		this.load(this.http, this.dom, this.trans.lang, 'abbr').then(x => this.content = x);
	}

}
